export default function UploadResumeIco() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8573 5.69036C15.3391 6.17208 15.5799 6.41293 15.7068 6.71922C15.8337 7.0255 15.8337 7.36612 15.8337 8.04737V14.1667C15.8337 15.738 15.8337 16.5237 15.3455 17.0118C14.8573 17.5 14.0717 17.5 12.5003 17.5H7.50033C5.92898 17.5 5.1433 17.5 4.65515 17.0118C4.16699 16.5237 4.16699 15.738 4.16699 14.1667V5.83333C4.16699 4.26198 4.16699 3.47631 4.65515 2.98816C5.1433 2.5 5.92898 2.5 7.50033 2.5H10.2862C10.9675 2.5 11.3082 2.5 11.6144 2.62687C11.9207 2.75373 12.1616 2.99459 12.6433 3.47631L14.8573 5.69036Z"
        stroke="#667085"
        stroke-width="1.6"
        stroke-linejoin="round"
      />
      <path
        d="M10 9.16797V13.3346"
        stroke="#667085"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0837 11.25H7.91699"
        stroke="#667085"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
